import { apiCall } from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";

export const institutionService = {
  getInstitutions, getInstitutionById, createInstitution, getFEPs
};

function getInstitutions(request) {
  const method = "GET";
  const apiUrl = API_URLS.INSTITUTION.GET_INSTITUTIONS;
  return apiCall(method, apiUrl, null, null, request);
}

function getInstitutionById(id) {
  const method = "GET";
  const apiUrl = `${API_URLS.INSTITUTION.GET_INSTITUTIONS}/${id}`;
  return apiCall(method, apiUrl, null, null);
}

function getFEPs() {
  const method = "GET";
  return apiCall(method, API_URLS.INSTITUTION.FEP, null, null);
}

function createInstitution(request) {
  const method =  request.id ? "PUT" : "POST";
  const url = method === "PUT" ? `${API_URLS.INSTITUTION.GET_INSTITUTIONS}/${request.id}` : API_URLS.INSTITUTION.GET_INSTITUTIONS
  return apiCall(method, url, null, request);
}